<template>
  <div>
    <b-container fluid class="header noselect">
      <b-row>
        <!-- Logo -->
        <b-col cols="8" offset="2" offset-lg="0" lg="2">
          <img class="p-2 mb-1 rounded-bottom logo mx-auto d-block" src="../../assets/img/easytick_color.png">
        </b-col>
        <!-- Sair Mobile -->
        <b-col cols="2" align-self="center" class="py-1 d-lg-none text-right">
          <p class="logout m-0">
            <router-link :to="{ name: 'Logout' }">
              <icon scale="1" name="power-off"></icon>
            </router-link>
          </p>
        </b-col>


        <b-col cols="12" lg="8" align-self="center" class="my-2">
          <h1 class="title text-center m-0">
            Olá, {{ user.name }}!
          </h1>
        </b-col>

        <!-- Sair Desktop -->
        <b-col lg="2" align-self="center" class="py-1 d-none d-lg-block text-right">
          <p class="logout m-0">
            <router-link :to="{ name: 'Logout' }">
              <icon scale="1" name="power-off"></icon>
            </router-link>
          </p>
        </b-col>

      </b-row>
    </b-container>

    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" md="9" lg="6">
          <h3 class="text-left my-3">Operações</h3>
          <b-list-group>
            <b-list-group-item v-for="event in events" :key="event.id" @click="link(event.token, event.type)" style="cursor: pointer;">
              <div class="text-center d-table-cell align-middle overflow-hidden bg-white rounded" style="width: 80px; height: 80px;">
                <b-img style="max-width: 100%; max-height: 100%;" :src="event.image"></b-img>
              </div>
              <span class="pl-3 d-table-cell align-middle">
                <b-badge class="mx-1" variant="light">{{ event.type | capitalize }}</b-badge>
                {{ event.name }}
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

      <b-row align-h="center" class="mt-4">
        <b-col cols="12" md="9" lg="6" v-if="groupedReports && groupedReports.length > 0">
          <h3 class="text-left my-3">Relatórios</h3>
          <b-list-group>
            <b-list-group-item v-for="groupedReport in groupedReports" :key="groupedReport.id" @click="openGroupedReport(groupedReport.token)" style="cursor: pointer;">
              <span class="pl-3 d-table-cell align-middle">
                {{ groupedReport.name }}
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
export default {
  name: 'OrganizerEvents',
  data () {
    return {
      user: '',
      events: '',
      groupedReports: '',
    }
  },
  async created () {
    await this.getEvents()
  },
  methods: {
    async getEvents () {
      try {
        let resp = await this.$http.get(process.env.VUE_APP_URL_APP + '/b/organizers/events')
        this.user = resp.body.user
        this.events = resp.body.events
        this.groupedReports = resp.body.grouped_reports
      } catch (e) {
        console.error(e)
      }
    },
    link (token, type) {
      this.$session.set('type', type)
      this.$router.push({
        name: 'OrganizerOverview',
        params: {organizer: token},
      })
      window.scrollTo(0,0)
    },
    openGroupedReport (token) {
      this.$router.push({
        name: 'OrganizerShowGroupedReport',
        params: {token: token},
      })
    },
  }
}
</script>
